import React from 'react';
import Link from 'next/link';

interface JourneyCTAProps {
  title?: string;
  description?: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
  showSecondaryButton?: boolean;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
}

export default function JourneyCTA({
  title = "Ready to Start Your Journey?",
  description = "Join thousands of families who have found their perfect match through Bhagyavivah",
  primaryButtonText = "Register Now in 2 minutes",
  primaryButtonLink = "/register",
  showSecondaryButton = false,
  secondaryButtonText = "Contact Support",
  secondaryButtonLink = "/contact"
}: JourneyCTAProps) {
  return (
    <section className="py-16 bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">
          {title}
        </h2>
        <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
          {description}
        </p>
        <div className="flex justify-center">
          <Link
            href={primaryButtonLink}
            className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-full font-medium text-lg tracking-wide transition-all duration-300 transform hover:-translate-y-1 shadow-lg"
          >
            {primaryButtonText}
          </Link>
          {showSecondaryButton && (
            <Link
              href={secondaryButtonLink}
              className="border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white px-8 py-4 rounded-full font-medium text-lg tracking-wide transition-all duration-300 ml-4"
            >
              {secondaryButtonText}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
